module.exports = __webpack_public_path__ + "static/media/hostel-details-image.3e818cd0.png";